import React, { useEffect, useState } from "react";
import CallHistory from "./call-history";
import { fetchAIAgentCallLogs } from "../../../js/api/call-log";
import { IconCallLogNoData } from "../../../assets/icons/icon-call-log-no-data";
import { useLocation } from "react-router";

const AIAgentsCallLogs = ({ trialInfo, loading, setLoading }) => {
  const [trialInfoData, settrialInfoData] = useState(null);
  const [callData, setCallData] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
  }, [location]);

  useEffect(() => {
    settrialInfoData(trialInfo);
  }, [trialInfo]);

  useEffect(() => {
    const fetchCallHistory = async () => {
      try {
        const response = await fetchAIAgentCallLogs(
          trialInfoData.patientTrialJuncID
        );
        if (response.data.items && response.data.items.length > 0) {
          const data = response.data.items.map((item) => ({
            ...item,
            duration: item.durationSec,
            callStatus: item.status,
          }));
          setCallData(data);
        } else {
          setCallData([]);
        }
      } catch (error) {
        console.error("Failed to fetch call history:", error);
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      } finally {
      }

      setTimeout(() => {
        setLoading(false);
      }, 1500);
    };

    if (trialInfoData) {
      fetchCallHistory();
    }
  }, [trialInfoData]);

  if (loading) {
    return (
      <div className="h-[50vh] flex justify-center items-center">
        <div className="mini-spinner"></div>
      </div>
    );
  }
  return (
    <div className="">
      {callData && callData.length === 0 && (
        <>
          <div className="text-center w-[100%] mb-5 flex justify-center">
            <IconCallLogNoData />
          </div>
          <p className="text-center w-[100%]">
            No call logs available for this patient
          </p>
        </>
      )}
      <div className="max-h-[55vh] overflow-y-auto pr-2">
        <CallHistory
          calls={callData}
          trialInfo={trialInfoData}
          isAICallHistory={true}
        />
      </div>
    </div>
  );
};

export default AIAgentsCallLogs;
